var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-wrapper p-4"},[_c('button',{staticClass:"px-10 py-4 rounded-sm",attrs:{"disabled":_vm.disabled,"type":_vm.type,"id":_vm.id},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }